import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CONSTANTS_DETAILS } from './../../model';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth/auth.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { AppService } from '../../../services/app-service/app.service';

@Component({
  selector: 'app-header',
  imports: [
    MatMenuModule,
    TranslateModule,
    MatIconModule,
    NgOptimizedImage,
    MatFormFieldModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  public isLogoutMenuOpen = false;
  public authService = inject(AuthService);
  public userProfile = this.authService.getAccountGroups();
  public activeUserRoles = signal<string[]>([]);
  public APP_NAME: string = CONSTANTS_DETAILS.APP_NAME;
  private router = inject(Router);
  public appService = inject(AppService);
  /**
   * Angular lifecycle hook that initializes the component after constructor
   *
   * @memberof HeaderComponent
   */
  public ngOnInit() {
    this.authService.userRoles.subscribe((roles) => {
      if (roles && roles) {
        const rolesData = roles;
        this.activeUserRoles.set(Array.isArray(rolesData) ? rolesData : []);
      }
    });
  }

  /**
   * Checks if the current user has admin role
   *
   * @returns {boolean} True if user has admin role
   * @memberof HeaderComponent
   */
  public isAdmin(): boolean {
    const roles = this.activeUserRoles();
    return roles.some((role) =>
      role.toLowerCase().includes('DigitalUpload-Admin'.toLowerCase()),
    );
  }

  /**
   * Logs out the user by calling the logoutUser method from AuthService.
   *
   * @memberof HeaderComponent
   */
  public logoutUser() {
    this.authService.logoutUser();
  }

  /**
   * Navigation to settings page
   *
   * @memberof HeaderComponent
   */
  public navigateToSettings() {
    this.router.navigate(['/home/settings']);
  }

  /**
   * Download report API called
   *
   * @memberof HeaderComponent
   */
  public downloadSummaryReport() {
    this.appService.downloadSummaryReport();
  }
}
